import React, { useEffect, useState } from 'react'
import clsx from 'clsx';
import { AppBar, Divider, Drawer, IconButton, List, makeStyles, Toolbar, Typography } from '@material-ui/core';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { useLocation } from 'react-router-dom';
import moment from 'moment';

import { MainListItems, MenuAccaunt } from '../ui/MainListItems';
import { COLORS_PROJECT, ROUTES_NAMES } from '../../constants';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { LogoKerunos } from '../ui/LogoKerunos';
import LogoBlank from '../../images/LogoKeraunosBlanco.png'




const drawerWidth = 240;


const { color_nav } = COLORS_PROJECT;

const useStyles = makeStyles((theme) => ({

    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
        color: 'white'
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        backgroundColor: color_nav,
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },

}));

export const NavBar = () => {

    const classes = useStyles()
    const [open, setOpen] = useState()

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const { pathname } = useLocation()


    const [date, setDate] = useState()

    useEffect(() => {
        const interval = setInterval(() => {
            setDate(moment().format('DD/MM/YYYY h:mm:ss a'))
        }, 1000);
        return () => clearInterval(interval)
    }, []);

    const { width } = useWindowDimensions();
    const [size, setSize] = useState(true)


    useEffect(() => {
        if (width <= 720) {
            setSize(false)
        } else {
            setSize(true)
        }
        return size
    }, [size, width])



    return (
        <>
            {/* navBar */}
            <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
                <Toolbar className={classes.toolbar}>
                    <IconButton onClick={handleDrawerOpen} edge="start" color="inherit" aria-label="open drawer"
                        className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
                    >
                        <MenuOpenIcon />
                    </IconButton>
                   
                    <div style={{width: '3%'}}>
                                <LogoKerunos image={LogoBlank} />
                    </div>

                    {size &&
                        <>

                            <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                                {ROUTES_NAMES[pathname]}
                            </Typography>
                        </>

                    }


                    <Typography component="h1" variant="subtitle1" color="inherit" noWrap className={classes.title}>
                        {date}
                    </Typography>

                    <MenuAccaunt />

                </Toolbar>
            </AppBar>
            {/* navBar */}

            {/* left site */}
            <Drawer open={open} variant="permanent" classes={{ paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose), }} >
                <div className={classes.toolbarIcon} >
                    <IconButton onClick={handleDrawerClose} className={classes.title}>
                        <Typography component="h1" variant="h5" color="initial" noWrap className={classes.title}>
                            Menu
                        </Typography>
                        <ChevronLeftIcon />
                    </IconButton>
                </div>
                <Divider />

                <List >
                    <MainListItems />
                </List>

                <Divider />
            </Drawer>
        </>
    )
}
